/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RedirectingInputs */

const en_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting...`)
};

const de_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiterleitung...`)
};

const fr_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirection...`)
};

const es_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirigiendo...`)
};

const it_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reindirizzamento...`)
};

const nl_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorverwijzen...`)
};

const pl_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekierowywanie...`)
};

const fi_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohjataan...`)
};

const da_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdirigerer...`)
};

const sv_common_redirecting = /** @type {(inputs: Common_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdirigerar...`)
};

/**
* | output |
* | --- |
* | "Redirecting..." |
*
* @param {Common_RedirectingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_redirecting = /** @type {((inputs?: Common_RedirectingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RedirectingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_redirecting(inputs)
	if (locale === "fr") return fr_common_redirecting(inputs)
	if (locale === "es") return es_common_redirecting(inputs)
	if (locale === "it") return it_common_redirecting(inputs)
	if (locale === "nl") return nl_common_redirecting(inputs)
	if (locale === "pl") return pl_common_redirecting(inputs)
	if (locale === "fi") return fi_common_redirecting(inputs)
	if (locale === "da") return da_common_redirecting(inputs)
	if (locale === "sv") return sv_common_redirecting(inputs)
	return en_common_redirecting(inputs)
});